/**
 * Format plan limits for display (same source as GET /api/account/plans fields).
 * Used by Plan Information and Signup pricing cards.
 */

export const formatOverage = (cents) => {
  if (cents == null) return '$0.75';
  return `$${(cents / 100).toFixed(2)}`;
};

export const formatLiveChatSeats = (seats) => {
  if (seats == null) return '1 Seat';
  if (seats >= 999) return 'Unlimited Live Chat Seats';
  return `${seats} Live Chat Seat${seats !== 1 ? 's' : ''}`;
};

export const formatStorage = (mb) => {
  if (mb == null) return '500MB';
  if (mb >= 1000) return `${mb / 1000}GB`;
  return `${mb}MB`;
};

export const formatChatbotAgents = (count) => {
  if (count == null) return '1 Chatbot Agent';
  if (count >= 999) return 'Unlimited Chatbot Agents';
  return `${count} Chatbot Agent${count !== 1 ? 's' : ''}`;
};

export const formatIntegratedTasks = (count) => {
  if (count == null) return '1 Integrated Task (i.e. update CRM)';
  return `${count} Integrated Task${count !== 1 ? 's' : ''} (i.e. update CRM)`;
};

/** True when plan is the free trial (plan code B). */
function isTrialPlan(plan) {
  const code = plan?.value ?? plan?.planCode;
  return code === 'B';
}

/** Build plan feature lines in Account Settings order from API plan object */
export function getPlanFeaturesInOrder(plan) {
  const conv = plan.monthlyConversations ?? 100;
  const overage = formatOverage(plan.overageCentsPerConversation);
  const agents = formatChatbotAgents(plan.aiAgents);
  const seats = formatLiveChatSeats(plan.liveChatSeats);
  const storage = `Storage ${formatStorage(plan.storageMb)}`;
  const tasks = formatIntegratedTasks(plan.integratedTasks);
  const lines = [`${conv} Monthly Conversations`];
  if (!isTrialPlan(plan)) {
    lines.push(`${overage} Overage`);
  }
  lines.push(agents, seats, storage, tasks);
  return lines;
}
